var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.064 0C6.78785 0 4.12891 2.66663 4.12891 5.9523C4.12891 9.23796 6.78785 11.9046 10.064 11.9046C13.3402 11.9046 15.9992 9.23796 15.9992 5.9523C15.9992 2.66663 13.3402 0 10.064 0ZM10.064 1.55277C12.4856 1.55277 14.4509 3.52376 14.4509 5.9523C14.4509 8.38083 12.4856 10.3518 10.064 10.3518C7.64251 10.3518 5.6772 8.38083 5.6772 5.9523C5.6772 3.52376 7.64251 1.55277 10.064 1.55277Z",
    fill: "#003032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1279 19.4097C20.1279 17.5567 19.394 15.7793 18.0872 14.4688C16.7805 13.1583 15.0082 12.4222 13.1605 12.4222C11.1674 12.4222 8.96052 12.4222 6.96734 12.4222C5.11971 12.4222 3.34742 13.1583 2.04066 14.4688C0.733893 15.7793 0 17.5567 0 19.4097C0 20.1644 0.299338 20.889 0.83092 21.4231C1.36353 21.9563 2.08607 22.2565 2.83855 22.2565H17.2893C18.0418 22.2565 18.7643 21.9563 19.297 21.4231C19.8285 20.889 20.1279 20.1644 20.1279 19.4097ZM18.5796 19.4097C18.5796 19.7534 18.4433 20.0816 18.2018 20.3248C17.9592 20.5671 17.632 20.7037 17.2893 20.7037H2.83855C2.49586 20.7037 2.16865 20.5671 1.92608 20.3248C1.68455 20.0816 1.5483 19.7534 1.5483 19.4097C1.5483 17.9687 2.1191 16.5857 3.13582 15.5671C4.1515 14.5475 5.53052 13.975 6.96734 13.975H13.1605C14.5974 13.975 15.9764 14.5475 16.9921 15.5671C18.0088 16.5857 18.5796 17.9687 18.5796 19.4097Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNew);
export default __webpack_public_path__ + "static/media/Account_new.a201a9e22192292249fa2047cf7eb95d.svg";
export { ForwardRef as ReactComponent };